/* Stone Grindz theme · pdp-main.js (deferred; sections/main-product). Port of build/pages/pdp/pdp.js without the
   prototype's template swapping: every size is its own product page (two real links), so nothing is swapped here.
   - quantity stones -> the hidden quantity inputs of every Add form on the page (sg-cart.js posts them), the amount on
     the buttons and the sticky bar; a variant select (products with real options) updates price and id
   - photos: swipe row on phones (progress track via SG.rows, sg-card.js); thumbnails from 900 px (tap only, never hover)
   - one-shot reveals: the map route draws itself, the flavor-scale stones settle (static under reduced motion)
   - tap-to-open rows, the sticky Add bar (phones, while the main button is off screen, hidden over the footer)
   - "All three origins": one tap adds the origin bars in one SG.cart.add call; the label follows the bag
   Add to bag itself (Adding… / Added / Just sold out) is sg-cart.js. Plain ES2017. */
(function () {
  'use strict';
  var SG = window.SG = window.SG || {};
  var WORDS = ['zero', 'one', 'two', 'three', 'four', 'five'];
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function bagIds() {
    if (SG.cart && SG.cart.variants) return SG.cart.variants;
    var t = document.querySelector('template[data-drawer-tpl]'), src = t ? t.content : document;
    return Array.prototype.map.call(src.querySelectorAll('.dr-item[data-variant]'), function (li) { return li.getAttribute('data-variant'); });
  }
  function money(c) { return SG.money ? SG.money(c) : '$' + (Math.round(c) / 100).toFixed(2).replace(/\.00$/, ''); }

  function init(scope) {
    var main = (scope && scope.querySelector && scope.querySelector('.pdp-main')) || document.querySelector('.pdp-main');
    if (!main || main.__sgPdp) return;
    main.__sgPdp = true;
    var add = main.querySelector('[data-pdp-add]'), qn = main.querySelector('[data-qn]');
    var q = 1, price = add ? +add.getAttribute('data-price') || 0 : 0;

    /* ---------- quantity + amount ---------- */
    function render() {
      if (!qn || !add) return;
      var max = parseInt(qn.getAttribute('data-max'), 10) || 20;
      if (q > max) q = max;
      if (q < 1) q = 1;
      qn.textContent = q;
      $$('[data-q]', main).forEach(function (b) {
        var dis = (b.getAttribute('data-q') === '-1' && q <= 1) || (b.getAttribute('data-q') === '1' && q >= max);
        b.setAttribute('aria-disabled', dis ? 'true' : 'false');
      });
      $$('[data-pdp-qty]', main).forEach(function (i) { i.value = q; });
      var amt = money(price * q);
      $$('[data-add-amt]', main).forEach(function (a) { if (a.closest('[aria-busy="true"]')) return; a.textContent = amt; });
      var nm = add.getAttribute('data-name') || '';
      $$('form[data-sg-add] [data-add]', main).forEach(function (b) {
        if (b.closest('.sgc')) return;
        b.setAttribute('aria-label', 'Add to bag: ' + (q > 1 ? q + ' × ' : '') + nm + ', ' + amt);
      });
      var sp = main.querySelector('[data-sticky-p]');
      if (sp) sp.textContent = sp.textContent.replace(/\$[\d.,]+$/, amt);
    }
    var sel = main.querySelector('[data-pdp-variant]');
    if (sel) sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      price = +o.getAttribute('data-price') || price;
      $$('[data-pdp-id]', main).forEach(function (i) { i.value = sel.value; });
      var pr = main.querySelector('[data-pdp-price]'); if (pr) pr.textContent = money(price);
      render();
    });

    /* ---------- photos ---------- */
    function showSlide(i) {
      $$('[data-slide]', main).forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-slide') === String(i)); });
      $$('[data-thumb]', main).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-thumb') === String(i) ? 'true' : 'false'); });
    }
    var gal = main.querySelector('[data-gal]');
    if (gal) setTimeout(function () { $$('img[loading="lazy"]', gal).forEach(function (i) { i.loading = 'eager'; }); }, 1200);
    if (SG.rows) SG.rows(main);

    /* ---------- one-shot reveals ---------- */
    var io = [];
    var els = $$('[data-reveal]', main);
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (els.length) {
      if (!('IntersectionObserver' in window) || still) els.forEach(function (el) { el.classList.add('is-in'); });
      else {
        main.setAttribute('data-rv', '');
        var o = new IntersectionObserver(function (es) {
          es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); o.unobserve(en.target); } });
        }, { rootMargin: '0px 0px -18% 0px', threshold: 0.25 });
        els.forEach(function (el) { o.observe(el); });
        io.push(o);
      }
    }

    /* ---------- sticky Add bar ---------- */
    var bar = main.querySelector('[data-sticky]');
    if (bar && add && 'IntersectionObserver' in window) {
      var off = false, foot = false, mq = window.matchMedia('(max-width:899px)');
      var set = function () {
        var on = mq.matches && off && !foot;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      };
      var a = new IntersectionObserver(function (es) { es.forEach(function (en) { off = !en.isIntersecting; }); set(); });
      a.observe(add);
      var ft = document.querySelector('.site-footer');
      if (ft) { var b = new IntersectionObserver(function (es) { es.forEach(function (en) { foot = en.isIntersecting; }); set(); }); b.observe(ft); }
    }

    /* ---------- all three origins ---------- */
    var tb = main.querySelector('[data-add-set]');
    function list() { try { return JSON.parse(tb.getAttribute('data-add-set')); } catch (e) { return []; } }
    function trio() {
      if (!tb || tb.__busy) return;
      var have = {}; bagIds().forEach(function (id) { have[String(id)] = true; });
      var all = list(), left = all.filter(function (i) { return !have[String(i.id)]; });
      var sum = left.reduce(function (n, i) { return n + i.price; }, 0), face = tb.querySelector('.pop-face');
      var word = tb.getAttribute('data-word') || WORDS[all.length] || all.length;
      if (!left.length) { face.textContent = (tb.getAttribute('data-in') || 'All [count] are in your bag').replace('[count]', word); tb.disabled = true; }
      else {
        tb.disabled = false;
        face.textContent = left.length === all.length ? (tb.getAttribute('data-all') || 'All [count] origins').replace('[count]', word) + ' · ' + money(sum) : 'Add the other ' + (WORDS[left.length] || left.length) + ' · ' + money(sum);
      }
      tb.setAttribute('aria-label', left.length ? 'Add to bag: ' + left.map(function (i) { return i.name; }).join(', ') + '. ' + money(sum) + ' in all.' : face.textContent);
    }
    if (tb) {
      
      trio();
      document.addEventListener('sg:cart', function () { if (!tb.__busy) trio(); });
    }

    /* ---------- delegated taps ---------- */
    main.addEventListener('click', function (ev) {
      var t = ev.target;
      var qb = t.closest('[data-q]');
      if (qb) { if (qb.getAttribute('aria-disabled') !== 'true') { q += parseInt(qb.getAttribute('data-q'), 10); render(); } return; }
      var th = t.closest('[data-thumb]');
      if (th) { showSlide(th.getAttribute('data-thumb')); return; }
      var acc = t.closest('.pdp-acc-btn');
      if (acc) {
        var open = acc.getAttribute('aria-expanded') !== 'true';
        acc.setAttribute('aria-expanded', open ? 'true' : 'false');
        var pnl = document.getElementById(acc.getAttribute('aria-controls')); if (pnl) pnl.hidden = !open;
        return;
      }
      var setb = t.closest('[data-add-set]');
      if (setb && !setb.disabled && SG.cart) {
        var have = {}; bagIds().forEach(function (id) { have[String(id)] = true; });
        var items = list().filter(function (i) { return !have[String(i.id)]; }).map(function (i) { return { id: i.id, quantity: 1 }; });
        if (!items.length) return;
        var face = setb.querySelector('.pop-face');
        face.textContent = (SG_CFG.t && SG_CFG.t.adding) || 'Adding…';
        setb.__busy = true;
        SG.cart.add(items, setb).then(function () {
          face.textContent = (SG_CFG.t && SG_CFG.t.added) || 'Added';
          if (SG.say) SG.say('Added all ' + (setb.getAttribute('data-word') || '') + ' origins to your bag.');
          setTimeout(function () { setb.__busy = false; trio(); }, 1600);
        }).catch(function () { setb.__busy = false; trio(); });
      }
    });
    render();
  }
  var SG_CFG = window.SG_CFG || {};
  if (SG.ready) SG.ready(init); else document.addEventListener('DOMContentLoaded', function () { init(document); });
})();
